import { ListTeleShifts } from "~/domain/usecases/shifts/remote";

import {
  InvalidCredentialsError,
  UnexpectedError,
  NotFound,
} from '~/domain/errors';
import { HttpClient, HttpStatusCode } from '~/data/protocols/http';

export class RemoteListTeleShifts implements ListTeleShifts {
  private readonly url: string;

  private readonly httpClient: HttpClient<ListTeleShifts.Model>

  constructor(url: string, httpClient: HttpClient<ListTeleShifts.Model>) {
    this.url = url;
    this.httpClient = httpClient;
  }

  list = async (
    params: ListTeleShifts.Params,
  ): Promise<ListTeleShifts.Model> => {
    const httpResponse = await this.httpClient.request({
      url: this.url,
      method: 'post',
      body: params,
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      case HttpStatusCode.notFound:
        throw new NotFound();
      default:
        throw new UnexpectedError();
    }
  }
}